<template>

  <div>


    <EnvironmentDialog :command="command"
                       v-if="modalDialogEnvironment"
                       :foreign-key="foreignKey"
                       :primary-key="form.environmentId"
                       :set-user-auth="userAuth"
                       :spotFolder="spotFolder"
                       :enable-sharing-public="enableSharingPublic"
                       :setTabIndex="modalDialogEnvironmentTabIndex"
                       @onClose="modalDialogEnvironment = false"
                       @onSubmit="onEnvironmentDialog"/>

    <t-dialog-duplicate dialog-id="modal-duplicate-environment" v-if="formDuplicateShow" :origin="formDuplicate.origin"
                        :path-server="currentPage.path" :form-error="formDuplicateError"
                        v-model="formDuplicate" :title="currentPage.singularTitle" @onSubmit="onDuplicated">

      <template #default="{status}">

        <t-input v-if="spotFolderResume !== null" v-model="spotFolderResume.enterprise" fixed label="Local"/>

        <t-input v-if="spotFolderResume !== null" v-model="spotFolderResume.division" fixed label="Divisão"/>

        <t-input hide-label :status="status" v-model="formDuplicate.environmentId" hidden/>

        <t-input label="Nome do Ambiente" :status="status" :add-error="formDuplicateError.name"
                 v-model="formDuplicate.changeName" required/>

      </template>

    </t-dialog-duplicate>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :change-order-params="'originChecklistId='+originChecklistId"
                 enable-change-order-up-down
                 sortable
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="environmentId" :primary-key="form.environmentId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Ambientes"
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit"
                 @onItemRead="onEnvironmentReadItem"
                 @onItemDelete="onDeleteEnvironment">

      <template #default>

        <div class="ml-1 mb-3 d-flex align-content-center">

          <t-button form-inline @click="openEnvironmentInsert" class="mr-2">
            <b-icon-plus/>
            {{ t('insert') + ' Ambiente' }}
          </t-button>


          <!--          <t-button :to="'place-report'"
                              form-inline
                              outline-secondary
                              target="_blank">
                      <b-icon-printer></b-icon-printer>
                      Imprimir QR Code
                    </t-button>-->


        </div>

      </template>

      <template #item(name)="{item}">


        <b-row>

          <b-col cols="4" v-if="accountModule !== 'estate'">

            <b-link @click="onEnvironmentReadItem(item.environmentId,2)">
              <t-image-blob v-if="item.floorPlanURL !== ''" :src="item.floorPlanURL"></t-image-blob>
              <div v-else
                   class="bg-light p-3 text-black justify-content-center align-content-center d-flex b-radius-small">
                <b-icon-camera-fill class="opacity-4"/>
              </div>
            </b-link>


          </b-col>

          <b-col cols="8">


            <b-link @click="onEnvironmentReadItem(item.environmentId,0)">{{ item.name }}</b-link>

            <small v-if="!item.enableSpecificItems"><br/>{{ item.typeEnvironment }}</small>
            <small v-if="item.spotSpecification !== ''"> - {{ item.spotSpecification }}</small>
            <small v-if="item.sharingEnable && item.spotFolderSharingEnable && enableSharingPublic"
                   class="text-success"><br/>QR Code
              <b-icon-check-circle-fill/>
            </small>


          </b-col>


        </b-row>


      </template>


      <template #item(qtyOccurrencePending)="{item}">

        <b-button v-if="item.qtyOccurrencePending > 0"
                  :to="{path: '/checklist/occurrence?environmentId='+item.environmentId+'&hasOccurrencePending=true'}"
                  variant="outline-primary" size="sm" target="_blank">
          <b-icon-box-arrow-up-right class="mr-2"/>
          Apontamentos
          <b-badge variant="warning">{{ item.qtyOccurrencePending }}</b-badge>
        </b-button>

        <small v-else>Não possui pendentes</small>

      </template>

      <template #item(lastChecklistEnvironmentFinishDate)="{item}">

        <b-button v-if="objValid(item.lastChecklistEnvironmentFinishDate)"
                  :to="{path: '/checklist/'+item.lastChecklistNumber}"
                  variant="outline-primary" size="sm" target="_blank">
          <b-icon-box-arrow-up-right class="mr-2"/>
          {{ item.lastChecklistEnvironmentFinishDate | date }}
        </b-button>

        <small v-else>Nunca inspecionado</small>

      </template>

      <template #append-default-buttons="{item}">

        <b-button @click="openDialogDuplicate(item.spotFolderId, item.environmentId, item.name)"
                  class="opacity-6-hover"
                  v-if="userAuth.validation.validationCreate" size="sm" variant="outline" v-b-tooltip.hover.ds500
                  title="Duplicar Ambiente">
          <b-icon-files variant="primary"/>
        </b-button>
      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import EnvironmentDialog from "@/views/modules/place/EnvironmentDialog";
import TDialogDuplicate from "@/components/template/dialog/t-dialog-duplicate";
import ui from "@/assets/scripts/ui";
import TImageBlob from "@/components/template/theme/t-image-blob";
import SpotFolderService from "@/services/modules/place/SpotFolder.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {TImageBlob, tFormList, EnvironmentDialog, TDialogDuplicate},
  name: 'EnterpriseEnvironment',
  data() {
    return {
      path: "place/environment", //Utilizar somente quando fora do padrão
      pathMethodComplement: "/selectAll",
      foreignKeyColumn: "spotFolderId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "environmentId", keyDelete: "environmentId"},
        {key: "name", label: "Ambiente", cols: "4"},
        {key: "spotFolder", label: "Pavimento", cols: "2"},
        {key: "division", label: "Divisão", cols: "2"},
      ],
      form: {
        spotFolderId: 0,
        lastChecklistEnvironmentFinishDate: "",
        hasOccurrencePending: null,
        sharingEnable: null,
        originChecklistId: 0,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      accountModule: "",
      modalDialogEnvironment: false,
      modalDialogEnvironmentTabIndex: 0,
      environmentIds: [],
      enableDeleteBulk: false,
      formDuplicateShow: false,
      formDuplicate: {
        environmentId: 0,
        spotFolderId: 0,
        changeName: "",
        origin: "",
      },
      formDuplicateError: {
        name: "",
      },
      spotFolderResume: null,
      enableSharingPublic: false,
      spotFolderOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    spotFolder: String,
    originChecklistId: {
      type: Number,
      default: 0,
    }

  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {
      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

    },

    mountedPrepare() {

      this.listParams.delete("enableBasicList")
      this.listParams.append("enableBasicList", true)

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      this.enableSharingPublic = this.getRenderRule('MODULE_ARCH_ENABLE_SHARING_PUBLIC') === 1

      await SpotFolderService.selectListGroupedByEnterpriseId(this.foreignKey).then(list => this.spotFolderOptions = list)

      await this.getList()

      this.accountModule = ui.getAccountModule()

    },

    async onSubmit() {

      //Quando é utilizado com base em um checklist deverá atualizar o mapeamento no mesmo
      this.form.originChecklistId = this.originChecklistId

      await this.setSendingFormListDefault(this.form.enterpriseId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    openEnvironmentInsert() {
      this.form.environmentId = 0
      this.command = 'insert'
      this.modalDialogEnvironment = true
      this.modalDialogEnvironmentTabIndex = 0
      this.openDialogForm('modal-place-environment')

    },
    onEnvironmentReadItem(id, tabIndex = 0) {
      this.form.environmentId = id
      this.command = 'update'
      this.modalDialogEnvironment = true
      this.modalDialogEnvironmentTabIndex = tabIndex
      this.openDialogForm('modal-place-environment')
    },

    async onEnvironmentDialog() {

      //Atualiza a listagem
      await this.getList()

    },
    openDialogDuplicate(spotFolderId, environmentId, origin) {

      this.formDuplicateShow = true
      this.formDuplicate.spotFolderId = spotFolderId
      this.formDuplicate.environmentId = environmentId
      this.formDuplicate.changeName = origin
      this.formDuplicate.origin = origin

      this.openDialogForm('modal-duplicate-environment')

    },

    onDuplicated(item) {

      this.formDuplicate.changeName = ""

      ui.toast(this, "Duplicado", "Novo ambiente <b>" + item.name + "</b> duplicado com sucesso!", "success", "b-toaster-top-center", true)

      this.getList()

    },
    onCancelDeleteBulk() {
      this.environmentIds = []
      this.enableDeleteBulk = false
    },
    async onDeleteBulk() {


      await this.executeDeleteByBulk(this.environmentIds,
          "Deseja realizar a exclusão em massa do(s) <b>" + this.environmentIds.length + "</b> ambiente(s) selecionado(s)?",
          async () => {
            ui.toast(this, "Exclusão", "Exclusão em massa realizada com sucesso!", "success", "b-toaster-top-center", true)
            this.onCancelDeleteBulk()
            await this.getPage(this.pageNumber);
          },
          async () => {
            this.onCancelDeleteBulk()
            await this.getPage(this.pageNumber);
          }
      )

    },
    onResumeSpotFolder(resume) {

      this.spotFolderResume = resume
    },

    async onDeleteEnvironment(id, callback) {

      let url = this.path + "/" + id

      if (this.originChecklistId > 0) {
        url += "/" + this.originChecklistId
      }

      await crudGeneral.delete(url).then(
          () => {

            this.actionDefaultAfterCRUD()

            if (callback)
              callback()
          }
      ).catch(error => ui.generalResponseError(this, error))
    },

    onSearchSpotFolder(value) {

      this.listParams.delete("spotFolderId")

      if (value > 0)
        this.listParams.append("spotFolderId", value)

      this.getList()
    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
